<template>
  <div class="d-widget-locus-card">
    <div class="d-widget-locus-card-header">
      <div class="d-widget-locus-card-title">
        {{widgetData.title}}
      </div>
      <!-- state -->
      <fts-state
        :state="widgetData.locusState"
        :states="states"
        class="d-widget-locus-card-state"
        v-if="widgetData.locusState"
      />
      <!-- assign -->
      <fts-assign-to
        :module-id="widgetData.vectorId"
        :form-data="widgetData"
        :max-length="3"
        view-mode
        avatar-mode 
        :avatar-size="22"
        disabled-date
        class="d-widget-locus-card-assign stopPropagation" 
        v-if="widgetData.assignees && widgetData.assignees.length"
      />
    </div>

    <div class="d-widget-locus-card-content">
      <div class="d-widget-locus-card-content__l">
        <!-- document -->
        <div class="d-widget-locus-card-document-id">
          {{widgetData.document.documentId}}
        </div>
        <!-- module -->
        <fts-label-group
          :item-id="widgetData.vectorId"
          :list="modules"
          emoji
          :emoji-size="12"
          class="d-widget-locus-card-module"
          v-if="widgetData.vectorId"
        />
      </div>
      <!-- audit created -->
      <div class="d-widget-locus-card-audit">
        <div class="d-widget-locus-card-audit-by">by</div>
        <fts-profile
          :userName="widgetData.audit.createdBy"
          class="d-widget-locus-card-audit-profile"
        />
        <fts-tippy
          class="d-widget-locus-card-audit-date"
          :content="moment(widgetData.audit.createdDate).format('llll')"
        >
          <template #trigger>
            {{dateFormat(widgetData.audit.createdDate)}}
          </template>
        </fts-tippy>
      </div>
    </div>

    <div class="d-widget-locus-card-footer">
      <div class="d-widget-locus-card-footer__l">
        <!-- collaboration -->
        <div
          class="d-collaboration fts-collaboration"
          v-if="widgetData.collaborationFlags && [1, 2, 5, 10].indexOf(widgetData.collaborationFlags) > -1"
        >
          <div
            class="collaboration-wrapper"
            v-if="widgetData.collaborationFlags === 2 || widgetData.collaborationFlags === 10"
          >
            <div 
              class="collaboration-trigger collaboration-intention"
              :class="{ 'collaboration-last': widgetData.collaborationFlags === 10}"
            >
              <i class="fts-icon-exclamation-triangle"></i>
            </div>
          </div>
          <div
            class="collaboration-wrapper"
            v-if="widgetData.collaborationFlags === 1 || widgetData.collaborationFlags === 5"
          >
            <div 
              class="collaboration-trigger collaboration-comment"
              :class="{ 'collaboration-last': widgetData.collaborationFlags === 5}">
              <i class="fts-icon-comment"></i>
            </div>
            <div class="collaboration-count" v-if="widgetData.commentCount">
              {{widgetData.commentCount}}
            </div>
          </div>
        </div>
        <!-- audit updated -->
        <div
          class="d-widget-locus-card-audit"
          v-if="widgetData.audit && widgetData.audit.updatedBy"
        >
          <fts-profile
            :userName="widgetData.audit.updatedBy"
            class="d-widget-locus-card-audit-profile"
          />
          <fts-tippy
            class="d-widget-locus-card-audit-date"
            :content="moment(widgetData.audit.updatedDate).format('llll')"
          >
            <template #trigger>
              {{dateFormat(widgetData.audit.updatedDate)}}
            </template>
          </fts-tippy>
        </div>
      </div>
      <!-- due -->
      <fts-tippy 
        :content="moment(widgetData.due).format('ll')" 
        class="d-widget-locus-card-due" 
        :class="{'d-widget-locus-card-due--overdue': overdue(widgetData.due)}"
        v-if="widgetData.due"> 
        <template #trigger>{{calendarRelativeTime(widgetData.due)}}</template>
      </fts-tippy>
    </div>
  </div>
</template>

<script>

import moment from "moment";

import FTSTippy from "../../elements/FTSTippy";
import FTSProfile from "../../elements/FTSProfile";
import FTSState from "../../elements/FTSState";
import FTSAssignTo from "../../elements/FTSAssignTo"
import FTSLabelGroup from "../../elements/FTSLabelGroup";
import commons from '../../commons/commons';

export default {
  props: {
    modules: Array,
    states: Array,
    widgetData: Object,
  },
  components: {
    "fts-tippy": FTSTippy,
    "fts-profile": FTSProfile,
    "fts-state": FTSState,
    "fts-assign-to": FTSAssignTo,
    "fts-label-group": FTSLabelGroup,
  },
  methods: {
    moment,
    dateFormat(date) {
      return commons.momentRelativeTime(date);
    },
    calendarRelativeTime(date) {
      return commons.calendarRelativeTime(date);
    },
    overdue(date) {
      return moment(date).isBefore(moment().startOf('day'));
    },
  }
}
</script>

<style lang="scss" scoped>
@use "./src/assets/scss/vars" as *;
@use "./src/components/dashboard/widgets/scss/style";

.d-widget-locus-card {
  cursor: pointer;
  .d-widget-locus-card-header {
    .d-widget-locus-card-title {
      @include text-line-clamp($fontSize: 0.875rem, $lineHeight: 1.25rem, $lineClamp: 2);
      flex: 1 1 60%;
      margin-top: auto;
      margin-bottom: auto;
      font-weight: 500;
    }
  }
  .d-widget-locus-card-footer {
    .d-widget-locus-card-footer__l {
      flex: 1 1 50%;
      min-width: 0;
      display: flex;
      align-items: center;
      > *:not(:first-child) {
        margin-left: 0.75rem;
      }
    }
    .d-collaboration {
      font-size: 0.875rem;
    }
  }
}
</style>